// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: DMejI56rkF

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: FX7sJMOvuD/component
import TextInput from "../../TextInput"; // plasmic-import: TAzASWLFePH/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component
import Footer from "../../Footer"; // plasmic-import: WRs9bMrYcz/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicContactUsPage.module.css"; // plasmic-import: DMejI56rkF/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: f42r0km3yz4/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon

createPlasmicElementProxy;

export type PlasmicContactUsPage__VariantMembers = {};
export type PlasmicContactUsPage__VariantsArgs = {};
type VariantPropType = keyof PlasmicContactUsPage__VariantsArgs;
export const PlasmicContactUsPage__VariantProps = new Array<VariantPropType>();

export type PlasmicContactUsPage__ArgsType = {};
type ArgPropType = keyof PlasmicContactUsPage__ArgsType;
export const PlasmicContactUsPage__ArgProps = new Array<ArgPropType>();

export type PlasmicContactUsPage__OverridesType = {
  root?: p.Flex<"div">;
  header?: p.Flex<typeof Header>;
  banner?: p.Flex<"div">;
  foreground2?: p.Flex<"div">;
  h1?: p.Flex<"h1">;
  clientsSection5?: p.Flex<"div">;
  formWrapper?: p.Flex<"div">;
  name2?: p.Flex<"div">;
  nameTextBox?: p.Flex<typeof TextInput>;
  emailTextBox?: p.Flex<typeof TextInput>;
  messageTextBox?: p.Flex<"textarea">;
  submitButton?: p.Flex<typeof Button>;
  footer?: p.Flex<typeof Footer>;
  toastPlaceHolder?: p.Flex<"div">;
};

export interface DefaultContactUsPageProps {
  className?: string;
}

const $$ = {};

function PlasmicContactUsPage__RenderFunc(props: {
  variants: PlasmicContactUsPage__VariantsArgs;
  args: PlasmicContactUsPage__ArgsType;
  overrides: PlasmicContactUsPage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "nameTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "emailTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "messageTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
          />

          <div
            data-plasmic-name={"banner"}
            data-plasmic-override={overrides.banner}
            className={classNames(projectcss.all, sty.banner)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"foreground2"}
              data-plasmic-override={overrides.foreground2}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground2)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__r9Xt1)}
              >
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {hasVariant(globalVariants, "screen", "mobileOnly")
                    ? "Contact us"
                    : "Contact Us"}
                </h1>
              </p.Stack>
            </p.Stack>
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"clientsSection5"}
            data-plasmic-override={overrides.clientsSection5}
            hasGap={true}
            className={classNames(projectcss.all, sty.clientsSection5)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ymXB)}
            >
              <div className={classNames(projectcss.all, sty.columns__je5C4)}>
                <div className={classNames(projectcss.all, sty.column__ndVi)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ikD1H
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "Please don't hesitate to reach out to us if you have any questions, concerns, or feature requests. Our dedicated team is here to assist you, and you can expect a prompt response within 24-48 hours."
                      : "Please don't hesitate to reach out to us if you have any questions, concerns, or feature requests. Our dedicated team is here to assist you, and you can expect a prompt response within 24-48 hours."}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column__iV3Un)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.columns__ntpf4)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__urBrs)}
                    >
                      <div
                        data-plasmic-name={"formWrapper"}
                        data-plasmic-override={overrides.formWrapper}
                        className={classNames(projectcss.all, sty.formWrapper)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__h72G3
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__yug8
                            )}
                          >
                            <div
                              data-plasmic-name={"name2"}
                              data-plasmic-override={overrides.name2}
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.name2
                              )}
                            >
                              {"Name"}
                            </div>
                            <TextInput
                              data-plasmic-name={"nameTextBox"}
                              data-plasmic-override={overrides.nameTextBox}
                              className={classNames(
                                "__wab_instance",
                                sty.nameTextBox
                              )}
                              endIcon={
                                <ChecksvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__thiNa
                                  )}
                                  role={"img"}
                                />
                              }
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "nameTextBox",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              placeholder={""}
                              startIcon={
                                <SearchsvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__ttOd
                                  )}
                                  role={"img"}
                                />
                              }
                              value={
                                p.generateStateValueProp($state, [
                                  "nameTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__xCkao
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__mfpvG
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__zyaSf
                              )}
                            >
                              {"Email address"}
                            </div>
                            <TextInput
                              data-plasmic-name={"emailTextBox"}
                              data-plasmic-override={overrides.emailTextBox}
                              className={classNames(
                                "__wab_instance",
                                sty.emailTextBox
                              )}
                              endIcon={
                                <ChecksvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__wWK
                                  )}
                                  role={"img"}
                                />
                              }
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "emailTextBox",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              placeholder={""}
                              startIcon={
                                <SearchsvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__ki6Em
                                  )}
                                  role={"img"}
                                />
                              }
                              value={
                                p.generateStateValueProp($state, [
                                  "emailTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__zkfgq
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__rjnSt
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__aWJmF
                              )}
                            >
                              {"Message"}
                            </div>
                            <textarea
                              data-plasmic-name={"messageTextBox"}
                              data-plasmic-override={overrides.messageTextBox}
                              className={classNames(
                                projectcss.all,
                                projectcss.textarea,
                                sty.messageTextBox
                              )}
                              onChange={e => {
                                p.generateStateOnChangeProp($state, [
                                  "messageTextBox",
                                  "value"
                                ])(e.target.value);
                              }}
                              ref={ref => {
                                $refs["messageTextBox"] = ref;
                              }}
                              value={
                                p.generateStateValueProp($state, [
                                  "messageTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />

                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox___2SkN6
                              )}
                            >
                              <Button
                                data-plasmic-name={"submitButton"}
                                data-plasmic-override={overrides.submitButton}
                                className={classNames(
                                  "__wab_instance",
                                  sty.submitButton
                                )}
                                endIcon={
                                  <ChecksvgIcon
                                    className={classNames(
                                      projectcss.all,
                                      sty.svg__y8WGt
                                    )}
                                    role={"img"}
                                  />
                                }
                                startIcon={
                                  <ChecksvgIcon
                                    className={classNames(
                                      projectcss.all,
                                      sty.svg__eTqmj
                                    )}
                                    role={"img"}
                                  />
                                }
                                submitsForm={true}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text___7IdkA
                                  )}
                                >
                                  {"Submit"}
                                </div>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p.Stack>
                </div>
              </div>
            </p.Stack>
          </p.Stack>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />

          <div
            data-plasmic-name={"toastPlaceHolder"}
            data-plasmic-override={overrides.toastPlaceHolder}
            className={classNames(projectcss.all, sty.toastPlaceHolder)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "banner",
    "foreground2",
    "h1",
    "clientsSection5",
    "formWrapper",
    "name2",
    "nameTextBox",
    "emailTextBox",
    "messageTextBox",
    "submitButton",
    "footer",
    "toastPlaceHolder"
  ],
  header: ["header"],
  banner: ["banner", "foreground2", "h1"],
  foreground2: ["foreground2", "h1"],
  h1: ["h1"],
  clientsSection5: [
    "clientsSection5",
    "formWrapper",
    "name2",
    "nameTextBox",
    "emailTextBox",
    "messageTextBox",
    "submitButton"
  ],
  formWrapper: [
    "formWrapper",
    "name2",
    "nameTextBox",
    "emailTextBox",
    "messageTextBox",
    "submitButton"
  ],
  name2: ["name2"],
  nameTextBox: ["nameTextBox"],
  emailTextBox: ["emailTextBox"],
  messageTextBox: ["messageTextBox"],
  submitButton: ["submitButton"],
  footer: ["footer"],
  toastPlaceHolder: ["toastPlaceHolder"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  banner: "div";
  foreground2: "div";
  h1: "h1";
  clientsSection5: "div";
  formWrapper: "div";
  name2: "div";
  nameTextBox: typeof TextInput;
  emailTextBox: typeof TextInput;
  messageTextBox: "textarea";
  submitButton: typeof Button;
  footer: typeof Footer;
  toastPlaceHolder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicContactUsPage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicContactUsPage__VariantsArgs;
    args?: PlasmicContactUsPage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicContactUsPage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicContactUsPage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicContactUsPage__ArgProps,
          internalVariantPropNames: PlasmicContactUsPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContactUsPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContactUsPage";
  } else {
    func.displayName = `PlasmicContactUsPage.${nodeName}`;
  }
  return func;
}

export const PlasmicContactUsPage = Object.assign(
  // Top-level PlasmicContactUsPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    banner: makeNodeComponent("banner"),
    foreground2: makeNodeComponent("foreground2"),
    h1: makeNodeComponent("h1"),
    clientsSection5: makeNodeComponent("clientsSection5"),
    formWrapper: makeNodeComponent("formWrapper"),
    name2: makeNodeComponent("name2"),
    nameTextBox: makeNodeComponent("nameTextBox"),
    emailTextBox: makeNodeComponent("emailTextBox"),
    messageTextBox: makeNodeComponent("messageTextBox"),
    submitButton: makeNodeComponent("submitButton"),
    footer: makeNodeComponent("footer"),
    toastPlaceHolder: makeNodeComponent("toastPlaceHolder"),

    // Metadata about props expected for PlasmicContactUsPage
    internalVariantProps: PlasmicContactUsPage__VariantProps,
    internalArgProps: PlasmicContactUsPage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicContactUsPage;
/* prettier-ignore-end */
